import { http } from '../http';

type ServerResponse = {
  return_url: string;
  agent_return_url: string;
  clearcover_application_id: string;
  lead_metadata: {
    campaign_medium: string | null;
    campaign_name: string | null;
    lead_identifier: string | null;
    lead_name: string | null;
    partner_unstructured_metadata: string | null;
  };
  validation_errors: Array<unknown>;
};

export type LeadResults = {
  resumeLink: string;
  id: string;
  leadMetadata: {
    campaignMedium: string | null;
    campaignName: string | null;
    leadIdentifier: string | null;
    leadName: string | null;
    partnerUnstructuredMetadata: string | null;
  };
};

export const postLead = (token: string) => {
  return http
    .post<LeadResults>({
      url: '/api/v1/lead/attribution_link',
      token,
      transformResponse: (jsonData: string | ServerResponse): LeadResults => {
        const data: ServerResponse =
          typeof jsonData == 'string' ? JSON.parse(jsonData) : jsonData;

        return {
          id: data.clearcover_application_id,
          resumeLink: data.agent_return_url,
          leadMetadata: {
            campaignMedium: data.lead_metadata?.campaign_medium,
            campaignName: data.lead_metadata?.campaign_name,
            leadIdentifier: data.lead_metadata?.lead_identifier,
            leadName: data.lead_metadata?.lead_name,
            partnerUnstructuredMetadata:
              data.lead_metadata?.partner_unstructured_metadata,
          },
        };
      },
    })
    .catch(error => error.response);
};
